import * as Yup from 'yup';

export const payemntPlanInitialValues = (data) => {
    return {
        name: data?.name || null,
        notes: data?.notes || null,
        scheduledPayments: data?.scheduledPayments || [],
        purchaseData: data?.purchaseData || [],
        plaidTransactions: data?.plaidTransactions || [],
    };
};

export const payemntPlanSchema = Yup.object({
    name: Yup.string().required('Name is required').max(150, 'Name cannot be more than 150 characters'),
    notes: Yup.string().nullable().optional(),
    scheduledPayments: Yup.array().of(
        Yup.object().shape({
            date: Yup.date().required(),
            amount: Yup.number().required(),
        }),
    ),
});
